<template>
  <Breadcrumbs
      title="Manage Promotion"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Promotions', path: '/promotions' },
      { label: 'Manage Promotions', path: '/manage-promotions' }
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <managePromotionForm />
    </div>
  </div>
</template>

<script>
import managePromotionForm from './manage_promotion_form.vue'
export default {
  name: 'indexList',
  components: {
    managePromotionForm,
  },
}
</script>